import { get as _get } from 'lodash';
import { isBlank } from 'util/GeneralUtils';

import { AppConfigKey, AppConfigMap } from './appConfigMap';

/**
 * Get configuration value by using current stage, and a configuration key.
 * 
 * @param configKey - configuration key
 * @returns - configuration value
 */
export function getConfigValue(configKey: AppConfigKey) {
  const frameworkStage = _get(window, 'ARGO_CONFIG.argo.frameworkStage');
  const cellInfo = _get(window, 'ARGO_CONFIG.argo.cell');

  if (isBlank(frameworkStage) || isBlank(cellInfo)) {
    return null;
  }

  const configStageKey = frameworkStage + '.' + cellInfo;

  return _get(AppConfigMap, [configStageKey, configKey], null);
}
